import { Button, Flow, Modal, ModalBody, ModalHeader, Text } from 'bold-ui'

interface ModalNovidadeInativacaoImoveisProps {
  open: boolean
  onClose(): void
}

export function ModalNovidadeInativacaoImoveis(props: Readonly<ModalNovidadeInativacaoImoveisProps>) {
  const { open, onClose } = props

  return (
    <Modal size='small' open={open} closeOnBackdropClick={true} onClose={onClose}>
      <ModalHeader title='Novidade: Inativação de imóveis' />
      <ModalBody>
        <Flow direction='vertical' gap={1}>
          <Text>
            Agora é possível inativar um cadastro de imóvel duplicado, demolido ou assimilado, higienizando as listas de
            imóveis apresentados nas microáreas. Caso sua microárea tenha muitos imóveis para inativar, utilize a função{' '}
            <strong>{'Gestão de cadastros > Inativação de imóveis'}</strong>, no menu lateral.
          </Text>
          <Text>
            Um imóvel inativo ficará listado apenas na nova aba de "Inativos" do Acompanhamento do território e pode ser
            reativado com uma simples atualização. Até lá, não será enviado ao e-SUS Território nem contabilizado nos
            Relatórios Consolidados.
          </Text>
          <Flow direction='horizontal' justifyContent='flex-end'>
            <Button kind='primary' onClick={onClose}>
              Entendi
            </Button>
          </Flow>
        </Flow>
      </ModalBody>
    </Modal>
  )
}
